<template>
    <section>
        <m-art-edit :form.sync="form" :form-rules="rules" :resetFormCallback="resetFormCallback" :submit-success-func="submitSuccessFunc" :submit-func="submitFunc" :before-submit-func="beforeSubmitFunc" label-width="130px">
            <template v-slot:form-items>
                <m-card title="基本信息" v-loading="loading">
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="账号">{{ details.account }}</el-form-item>
                            <el-form-item label="角色" prop="roleId" id="parentMenuId">
                                <el-select v-model="form.roleId" placeholder="角色" multiple style="width: 100%;">
                                    <el-option v-for="item in allUserList" :value="item.id" :label="item.roleName" :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="承接问题">
                                {{ details.acceptorQuestion }}
                            </el-form-item>
                            <el-form-item label="关注问题">
                                {{ details.focusOnQuestion }}
                            </el-form-item>
                            <el-form-item label="电话">{{ details.phone }}</el-form-item>
                            <el-form-item label="描述" prop="remark">
                                <el-input type="textarea" resize="none" :rows="5" maxlength="100" show-word-limit placeholder="请输入内容" v-model="form.remark"></el-input>
                            </el-form-item>
                            <el-form-item label="是否启用">
                                <el-switch disabled v-model="form.status" active-value="Enable" inactive-value="Disable"></el-switch>
                            </el-form-item>
                            <el-form-item label="是否虚拟账号" prop="virtualAccount">
                                <el-switch v-model="form.virtualAccount"></el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </m-card>
            </template>
        </m-art-edit>
    </section>
</template>

<script>
import api from "plus/api";
import upload from "components/upload";
import detailsMixin from "@/mixin/detailsMixin";
import dialogEnum from "@/utils/dialogEnum";

export default {
    name: "privilege.user.details",
    components: { upload },
    mixins: [detailsMixin],
    data() {
        return {
            parentMenus: [],
            details: {},
            allUserList: [],
            form: {
                status: false,
                remark: "",
                roleId: [],
                virtualAccount: "",
            },
            virtualStatus: "",
            rules: {
                roleId: [{ required: true, message: "请选择角色" }],
                remark: [{ required: false, message: "描述字段不能为空" }],
            },
        };
    },
    computed: {
        submitFunc() {
            return this.isEdit ? api.manage.updateUser : api.manage.addMenuList;
        },
    },
    created() {
        if (this.isEdit) {
            api.manage
                .getUserById({ id: this.$route.query.id })
                .then((res) => {
                    const data = res.data.data;
                    this.form.status = data.status;
                    this.form.remark = data.remark;
                    this.form.roleId = data.roleId;
                    this.details = data;
                    this.virtualStatus = this.details.virtualAccount
                    this.form.virtualAccount = this.virtualStatus
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        api.manage.getAllUserList().then((res) => {
            this.allUserList = res.data.data;
        });
    },
    methods: {
        init() {},
        beforeSubmitFunc(form) {
            if (this.isEdit) {
                form.userId = this.$route.query.userId;
                form.remark =
                    form.remark ? form.remark.trim().length === 0 ? "" : form.remark :'';
            }
            form.roleId = form.roleId.join(",");
            return form;
        },
        submitSuccessFunc() {
            this.$message.success("提交成功");
        },
        resetFormCallback() {
            this.form.status = "Enable";
        },
    },
};
</script>
